export default __webpack_public_path__ + "static/media/sidebar-1.7f9ca0b4.png";